import { config } from 'state/product/config'
import { classList } from 'MK/DOM/fns/classList'

const sortKeys = {
  'default': 'Best Match',
  'date': 'Newest',
  'priceHigh': 'Price High to Low',
  'priceLow': 'Price Low to High',
  'title': 'Title',
  'rating': 'Customer Rating'
}

const sortOptionIDs = Object.keys(sortKeys)

const reverseSortKeys = {
  'priceHigh': true,
  'rating': true
}


export const sort = {
  initialize (Product) {
    MK.events.on('products:sort:update', (event = {}) => {
      if (!event || !event.target) {
        return
      }
      let [selection, selectedSortOrder] = [event.target, event.target.id]

      // If a selection and value are present, update product list to selected sort order.
      if (selection && selectedSortOrder) {
        console.log(`DEBUG (products:sort:update): Updating active product sort order: ${selectedSortOrder}`)

        MK.DOM.elements.byID['sort-selected'] = MK.DOM.elements.byID['sort-selected'] || document.getElementById('sort-selected')
        MK.DOM.elements.byID['sort-selected'].innerHTML = sortKeys[selectedSortOrder]

        let element = MK.DOM.fns.getElementById(config.selectors.id.sort.container)
        element && classList.has(element, 'active') && classList.remove(element, 'active')

        MK.events.emit('product:updateSort', {
          order: selectedSortOrder,
          reverse: !!reverseSortKeys[selectedSortOrder]
        })
      }
    })

    MK.events.on('products:sort:addClickEvents', (_event) => {
      // Iterate over each sort key and setup a corresponding ID-based click
      // event to toggle active class and update sort.
      // let sortOptionIDs = Object.values(sortKeys)
      sortOptionIDs.forEach(id => {
        // console.log(`DEBUG (products.sort.addClickEvents) Adding click event for sort option with ID: ${id}`)
        let element = MK.DOM.fns.getElementById(id)
        element.onclick = function (_event) {
          sortOptionIDs.forEach(id => {
            let fn = id === this.id ? 'add' : 'remove'
            classList[fn](MK.DOM.fns.getElementById(id), 'active')
          })

          MK.events.emit('products:sort:update', {
            target: this
          })

          return false
        }
      })

      MK.events.off('products:sort:addClickEvents')
    })


    MK.events.on('click:id:sort-selected', (event) => {
      // console.log('Sort Click', event)
      let element = MK.DOM.fns.getElementById(config.selectors.id.sort.container)
      classList.toggle(element, 'active')
    })

    MK.events.on('click:id:sort-label', (event) => {
      // console.log('Sort Click', event)
      let element = MK.DOM.fns.getElementById(config.selectors.id.sort.container)
      classList.toggle(element, 'active')
    })

    MK.events.on('product:updateSort', (sort) => {
      // Update active sort order if it's different from current sort order.
      if (sort.order !== Product.sort.order) {
        Product.sort = sort
        MK.events.emit('products:updateDOM', {
          initiator: 'MK.events.on("product:updateSort")'
        })
      }
    })

    MK.events.emit('products:sort:addClickEvents')
  }
}
